export const DEFAULT_STALE_TIME = 5 * 60 * 1000; // 5 minutes
export const DEFAULT_CACHE_TIME = 2 * 60 * 60 * 1000; // 2 hours

export const QUERY_CACHE_KEY = 'REACT_QUERY_OFFLINE_CACHE';
export const CURRENT_USER_ID_KEY = 'CURRENT_USER_ID';

export const getStoredUserId = (): string | null => {
  return window.localStorage.getItem(CURRENT_USER_ID_KEY);
};

export const setStoredUserId = (userId: number | string): void => {
  window.localStorage.setItem(CURRENT_USER_ID_KEY, String(userId));
};


export const clearStoredUserId = (): void => {
  window.localStorage.removeItem(CURRENT_USER_ID_KEY);
};


export const clearPersistedQueryCache = (): void => {
  window.localStorage.removeItem(QUERY_CACHE_KEY);
};

export const validateAndClearCacheIfUserChanged = (currentUserId: number | string): boolean => {
  const storedUserId = getStoredUserId();
  
  if (storedUserId && storedUserId !== String(currentUserId)) {
    clearPersistedQueryCache();
    return true;
  }
  
  return false;
};

